export default {
  props: ['menuItems', 'showMobileMenu'],
  data() {
    return {
      searchShow: false,
      searchArea: false,
      submenuBtn: false,
      userAva: false,
    };
  },
  computed: {
    title() {
      return this.$store.state.pageTitle;
    },
    submenu() {
      return this.$store.state.submenu;
    },
    user() {
      return this.$store.state.user;
    },
    extranet() {
      return this.$store.state.settings.extranet === true;
    },
    logoUrl() {
      return this.$store.state.settings.logoUrl;
    },
    newMobileNotifications() {
      return this.$store.state.mobileNotifications.notificationsNew;
    },
    cartLength() {
      return this.$store.state.shop.cart.cartLength;
    },
    tickets() {
      return this.$store.state.tickets.tickets;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userAvatar() {
      return this.$store.state.user.full_name
        .split(' ')
        .map(x => x[0])
        .join('');
    },
    isBlocked() {
      return !!(
        this.$store.state.user && this.$store.state.user.blocked_at !== null
      );
    },
  },
  methods: {
    SetSubmenu() {
      this.$store.dispatch('SetSubmenu', this.submenu ? '' : this.$route.name);
    },
    SetSidebar(status) {
      this.$store.dispatch('app/SetSidebar', status);
    },
    UserLogout() {
      console.log('logout');
      this.$store.dispatch('UserLogout');
      this.$router.push('/');
    },
  },
  destroyed() {
    this.$store.dispatch('SetSubmenu', '');
  },
  created() {
    if (this.user) {
      const getNotifications = () => {
        this.$store.dispatch(
          'mobileNotifications/GetNotifications',
          this.user.profile_id,
        );
      };
      getNotifications();
      setInterval(() => {
        getNotifications();
      }, 30000);
      // this.$store.dispatch('tickets/GetTickets', this.user.profile_id);
    }
  },
};
